export default {
  breadcrumb: {
    platform: 'Platform Admin',
    staff: 'Staff Management',
    add: 'Add Staff',
    edit: 'Edit Staff'
  },
  button: {
    back: 'Back',
    cancel: 'Cancel',
    save: 'Save',
    search: 'Search',
    refresh: 'Refresh',
    addUser: 'Add User',
    detail: 'Detail',
    edit: 'Edit',
    more: 'More',
    disable: 'Disable User',
    enable: 'Enable User',
    resetPwd: 'Reset Password',
    delete: 'Delete Organization',
    confirmDelete: 'Confirm Delete',
    confirm: 'Confirm'
  },
  form: {
    baseInfo: 'Basic Information',
    org: 'Organization',
    permission: 'Permission Settings',
    third: 'Third-party Integration',
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    status: 'User Status',
    branches: 'Branch',
    departments: 'Department',
    roles: 'All Roles',
    supervisors: 'Supervisor',
    cargoWareId: 'CargoWare User ID',
    eTowerId: 'eTower User ID',
    remark: 'Remark',
    usernamePlaceholder: 'Please enter username',
    emailPlaceholder: 'Please enter email',
    phonePlaceholder: 'Please enter phone number',
    statusPlaceholder: 'Please select user status',
    branchesPlaceholder: 'Please select branch',
    departmentsPlaceholder: 'Please select department',
    rolesPlaceholder: 'Please select role',
    supervisorsPlaceholder: 'Please select supervisor',
    cargoWareIdPlaceholder: 'Please enter CargoWare User ID',
    eTowerIdPlaceholder: 'Please enter eTower User ID',
    remarkPlaceholder: 'Please enter remark (optional)',
    usernameRequired: 'Please enter username',
    usernameMin: 'Username must be at least 2 characters',
    emailRequired: 'Please enter email',
    emailValid: 'Please enter a valid email address',
    phoneRequired: 'Please enter phone number',
    phoneValid: 'Please enter a valid phone number',
    statusRequired: 'Please select user status',
    branchesRequired: 'Please select branch',
    departmentsRequired: 'Please select department',
    rolesRequired: 'Please select role',
    saveSuccess: 'Staff added',
    updateSuccess: 'Staff info updated',
    avatarUpload: 'Upload Avatar',
    currentStatus: 'Current Status',
    pendingTip: 'New staff will be in pending status by default. They will be activated after first login.',
    addOrgGroup: 'Add Organization Group',
    orgGroupIndex: 'Organization Group {index}',
    orgGroupIncomplete: 'Please complete the existing organization group (branch and department) first',
    orgGroupRequired: 'Please select at least one complete organization group (branch and department)',
    orgGroupAtLeastOne: 'At least one organization group is required',
    mainOrgGroup: 'Primary Organization',
    setAsMainOrgGroup: 'Set as Primary',
    wechatWorkUserid: 'Wechat Work ID',
    wechatWorkUseridPlaceholder: 'Enter Wechat Work ID',
    englishName: 'English Name',
    englishNamePlaceholder: 'Enter English Name',
    landline: 'Landline',
    countryCode: 'Country Code',
    areaCode: 'Area Code',
    landlineNumberPlaceholder: 'Landline Number'
  },
  status: {
    active: 'Active',
    inactive: 'Disabled',
    pending: 'Pending',
    unknown: 'Unknown'
  },
  stats: {
    total: 'Total Users',
    active: 'Active Users',
    inactive: 'Disabled Users',
    pending: 'Pending'
  },
  table: {
    id: 'User ID',
    userInfo: 'User Info',
    contact: 'Contact',
    branches: 'Branch',
    departments: 'Department',
    roles: 'Role',
    supervisors: 'Supervisor',
    status: 'Status',
    lastLogin: 'Last Login',
    createTime: 'Created At',
    action: 'Action',
    wechatWorkUserid: 'Wechat Work ID',
    englishName: 'English Name',
    landline: 'Landline'
  },
  detail: {
    title: 'User Detail',
    avatar: 'Avatar',
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    branches: 'Company',
    roles: 'Role',
    status: 'Status',
    lastLogin: 'Last Login',
    createTime: 'Created At',
    id: 'User ID',
    wechatWorkUserid: 'Wechat Work ID'
  },
  modal: {
    disableTitle: 'Disable User Confirmation',
    enableTitle: 'Enable User Confirmation',
    disableConfirm: '⚠️ Disable Confirmation',
    enableConfirm: '✅ Enable Confirmation',
    disableText: 'User {username} will be disabled. The user will not be able to log in. Confirm?',
    enableText: 'User {username} will be enabled. The user will be able to log in. Confirm?',
    disableNote: 'Note: After disabling, the user cannot access the system, but data will be retained.',
    enableNote: 'Note: After enabling, the user will regain access.',
    resetPwdTitle: 'Reset Password Confirmation',
    resetPwdConfirm: '⚠️ Operation Confirmation',
    resetPwdText: 'The password for user {username} will be reset. Confirm?',
    resetPwdNote: 'Note: A random 8-digit password will be generated and sent to the user email.',
    deleteTitle: 'Are you sure to delete this user?',
    deleteContent: 'After deletion, all information of user {username} cannot be recovered.'
  },
  message: {
    searchSuccess: 'Search completed',
    refreshSuccess: 'Data refreshed',
    showAll: 'Show all users',
    showActive: 'Filter active users',
    showInactive: 'Filter disabled users',
    showPending: 'Filter pending users',
    autoFilter: 'Auto filtered company: {company}',
    resetPwdSuccess: 'Password for user {username} has been reset',
    deleteSuccess: 'User {username} deleted',
    disableSuccess: 'User {username} disabled',
    enableSuccess: 'User {username} enabled',
    pleaseFillInCompleteOrganizationStructure: 'Please complete the existing organization group (branch and department) first',
    atLeastOneOrganizationStructureRequired: 'At least one complete organization group (branch and department) is required',
    formValidateFailed: 'Form validation failed, please check your input.',
    employeeUpdatedSuccessfully: 'Staff updated successfully',
    employeeAddedSuccessfully: 'Staff add successfully',
    atLeastOneMainRequired: 'At least one primary organization is required',
    exactlyOneMainRequired: 'Exactly one primary organization is required'
  },
  options: {
    roles: {
      superAdmin: 'Super Admin',
      deptManager: 'Department Manager',
      csManager: 'Customer Service Manager',
      user: 'User',
      ops: 'Operations',
      financeManager: 'Finance Manager',
      hr: 'HR',
      techLead: 'Tech Lead',
      productManager: 'Product Manager',
      marketing: 'Marketing'
    },
    branches: {
      hll: 'Huolala Logistics Co., Ltd.',
      hllSouth: 'Huolala South Branch',
      sf: 'SF Express Group',
      sfNorth: 'SF North Branch',
      db: 'Deppon Logistics Co., Ltd.',
      dbEast: 'Deppon East Branch',
      zt: 'ZTO Express Co., Ltd.',
      st: 'STO Express Co., Ltd.'
    },
    departments: {
      logistics: 'Logistics',
      tech: 'Technology',
      cs: 'Customer Service',
      marketing: 'Marketing',
      ops: 'Operations',
      finance: 'Finance',
      audit: 'Audit',
      hr: 'HR',
      product: 'Product'
    },
    supervisors: {
      zhangsan: 'Zhang San',
      lisi: 'Li Si',
      wangwu: 'Wang Wu',
      zhaoliu: 'Zhao Liu',
      chenqi: 'Chen Qi',
      sunba: 'Sun Ba',
      zhoujiu: 'Zhou Jiu'
    }
  },
  title: {
    addEmployee: 'Add Staff',
    editEmployee: 'Edit Staff'
  }
}
